import React, { useEffect, useState } from "react";
import { CommonForm, Spinner } from "../../../Components/Common";

const MaterialModal = ({
  title,
  formData,
  onChange,
  onSave,
  onClose,
  isSubmitting,
  fields,
  labels,
  disableSave,
}) => {
  const readOnlyFields =
    formData.material_delivery_status === "DELIVERED"
      ? Object.keys(fields).filter((f) => f !== "file")
      : [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg relative">
        <h2 className="text-lg font-semibold mb-4">{title}</h2>
        <CommonForm
          formData={formData}
          handleChangeData={onChange}
          // formData={updatedFormData} // ✅ use local state
          // handleChangeData={handleFieldChange} // ✅ use local handler
          renderField={fields}
          formFieldLabels={labels}
          isSubmitting={isSubmitting}
          // disabledFields={disabledFields}
          readOnlyFields={readOnlyFields}
        />
        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="bg-gray-300 px-4 py-2 rounded"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            className={`${
              isSubmitting || disableSave
                ? "bg-secondary cursor-not-allowed"
                : "bg-primary hover:bg-secondary"
            } text-white px-4 py-2 rounded`}
            disabled={isSubmitting || disableSave}
          >
            {isSubmitting ? <Spinner /> : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaterialModal;
